import type { IGetUserProfileResponse } from '../../../repositories/chats/entities/user_profile/GetUserProfileResponse';
import type { IUserProfileClientInfo } from '../../../types/userProfile';
import { mapPromo } from './mapPromo';
import { mapRecentlyWatchedOffers } from './mapRecentlyWatchedOffers';
import { mapSearchInfo } from './mapSearchInfo';
import { mapStatistics } from './mapStatistic';

export const mapClientInfo = (clientInfo: IGetUserProfileResponse['clientInfo']): IUserProfileClientInfo | null => {
  if (!clientInfo) {
    return null;
  }

  const { searchInfo, statistic, recentlyWatchedOffers, promo } = clientInfo;

  return {
    searchInfo: mapSearchInfo(searchInfo),
    statistics: mapStatistics(statistic),
    recentlyWatchedOffers: mapRecentlyWatchedOffers(recentlyWatchedOffers),
    promo: mapPromo(promo),
  };
};
